import { ProgramContentListItem } from '@cibo/core'
import { useProgramContent } from '@cibo/programs'
import { ContentfulBackgroundImage, Markdown } from '@cibo/ui'
import { Box, Grid, Skeleton, Stack, Typography } from '@mui/material'
import { ApprovedPartners } from './ApprovedPartners'
import imgUrl from './assets/geo_dark_blue.png'

export const Headline = ({ programId }: Pick<ProgramContentListItem, 'programId'>) => {
  const program = useProgramContent(programId)

  let logo = <Skeleton width={'100%'} height="220px" />
  let longDescriptionComponent = (
    <>
      <Skeleton variant="text" />
      <Skeleton variant="text" />
      <Skeleton variant="text" />
      <Skeleton variant="text" />
    </>
  )
  let titleComponent = <Skeleton />
  let shortDescriptionComponent = <Skeleton />

  if (program.data?.content) {
    const {
      logo: { fields },
      title,
      shortDescription,
      longDescription,
    } = program.data.content.fields
    logo = fields ? (
      <ContentfulBackgroundImage
        fields={fields}
        backgroundPosition="top"
        backgroundSize="contain"
        flex={1}
        preferTransparency
      />
    ) : (
      <Stack sx={{ height: '100%', mx: 3 }}>
        <Box
          sx={{
            backgroundImage: `url(${imgUrl})`,
            backgroundPositionX: 'center',
            height: 80,
            width: 80,
            borderRadius: '50%',
          }}
        />
      </Stack>
    )
    longDescriptionComponent = <Markdown color="text.secondary">{longDescription || ''}</Markdown>
    titleComponent = <>{title}</>
    shortDescriptionComponent = <>{shortDescription}</>
  }

  return (
    <Stack spacing={2}>
      <Box
        sx={{
          backgroundColor: 'background.paper',
          borderBlock: 'solid 1px',
          borderColor: 'rgba(0, 0, 0, 0.12)',
        }}
        py={2}
        pb={4}
      >
        <Grid container spacing={3}>
          <Grid xs={12} md={2} sx={{ display: 'flex', flexDirection: 'row', minHeight: 120 }} item>
            {logo}
          </Grid>
          <Grid xs={12} md={10} item>
            <Box>
              <Stack spacing={{ xs: 2, md: 3 }}>
                <Typography
                  variant="h4"
                  textAlign={{ xs: 'center', md: 'left' }}
                  color="text.secondary"
                >
                  {titleComponent}
                </Typography>
                <Typography
                  variant="h6"
                  textAlign={{ xs: 'center', md: 'left' }}
                  color="text.secondary"
                >
                  {shortDescriptionComponent}
                </Typography>

                <ApprovedPartners programId={programId} />

                <Markdown color="text.secondary">
                  {program.data?.content.fields.bulletedDescription || ''}
                </Markdown>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box py={2}>
        <Grid justifyContent="center" container>
          <Grid xs={12} md={10} lg={8} item>
            <Typography color="text.light">{longDescriptionComponent}</Typography>
          </Grid>
        </Grid>
      </Box>
    </Stack>
  )
}
